import { Box, TableCell, TableRow } from '@mui/material'
import { EthAddress } from '@xylabs/sdk-js'
import { EthAccountButton, TokenAmount } from '@xylabs/sdk-react'
import { XyoWorldMinterEvents } from '@xyo-network/world-typechain'

import { parseBigNumber } from '../../../parseBigNumber'
import EthBlock from '../../EthBlock'

interface Props {
  event: XyoWorldMinterEvents.BidPlaced | null
}

const Row: React.FC<Props> = (props) => {
  const { event } = props
  const { blockNumber, args } = event ?? {}
  const { by, amount } = args ?? {}

  const address = EthAddress.fromString(by?.toString())
  const amountBN = parseBigNumber(amount ?? '')

  return (
    <TableRow>
      <TableCell padding="none">
        <Box display="flex" justifyContent="center" paddingY={1}>
          <EthBlock block={blockNumber} />
        </Box>
      </TableCell>
      <TableCell padding="none">
        <Box display="flex" justifyContent="center" padding={1}>
          <EthAccountButton variant="outlined" sx={{ display: { sm: 'flex', xs: 'none' } }} address={address} />
          <EthAccountButton variant="outlined" sx={{ display: { sm: 'none' } }} address={address} iconOnly />
        </Box>
      </TableCell>
      <TableCell padding="none">
        <Box display="flex" justifyContent="center" paddingY={1}>
          <Box display="flex">{by ? <TokenAmount amount={amountBN} /> : null}</Box>
        </Box>
      </TableCell>
    </TableRow>
  )
}

export default Row
